import ConnectToSuppliersStore from './ConnectToSuppliersStore'

export default ConnectToSuppliersStore
